import { memo } from "react";
import * as page from "./page.module.css";
import { VersionFourNavbar } from "./version-four-navbar";

export const Page = memo(function Page({
  children,
}: {
  children: React.ReactElement;
}) {
  return (
    <div className={page.pageWrapper}>
      <VersionFourNavbar />
      <div className={page.main}>{children}</div>
    </div>
  );
});
